import { render } from "./CreateTrekEvent.vue?vue&type=template&id=d19c81c8&scoped=true"
import script from "./CreateTrekEvent.vue?vue&type=script&lang=js"
export * from "./CreateTrekEvent.vue?vue&type=script&lang=js"

import "./CreateTrekEvent.vue?vue&type=style&index=0&id=d19c81c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d19c81c8"]])

export default __exports__